import type { ApiResponse } from "../models/ApiResponse";
import type { ProcessResponse } from "../models/ProcessResponse";
import { getAxios } from "../helpers/api";
import { config } from '../environments/environment'

export interface DefectInput {
    speciesId: number;
    stockNumber: string;
    contractorNumber: string;
    remark: string;
}

export interface Defect extends DefectInput {
    defectId: number;
    speciesName?: string;
    speciesCode?: string;
    dateCreated: string;
}

class _DefectService {
    private baseUrl = config.url.STOCK_API_URL;

    async AddDefect(input: DefectInput): Promise<ProcessResponse> {
        try {
            const res = await getAxios(this.baseUrl).post("/Stock/add/defect", input);
            const data = res.data as ApiResponse<any>;
            if (data.isSuccessful) return { Successful: true, message: data.message || "Defect logged", data: data.data };

            return { Successful: false, message: data.message ?? "Unable to log defect. Please try again" }
        } catch (error) {
            return { Successful: false, message: "An error occurred. Please try again later" };
        }
    }

    async UpdateDefect(defectId: number, input: DefectInput): Promise<ProcessResponse> {
        try {
            const res = await getAxios(this.baseUrl).post("/Stock/update/defect", { defectId, ...input });
            const data = res.data as ApiResponse<any>;
            if (data.isSuccessful) return { Successful: true, message: data.message || "Defect updated" };

            return { Successful: false, message: data.message ?? "Unable to update defect. Please try again" }
        } catch (error) {
            return { Successful: false, message: "An error occurred. Please try again later" };
        }
    }

    async GetAllDefects(): Promise<Defect[] | null> {
        try {
            const res = await getAxios(this.baseUrl).get("/Stock/get/defects");
            const response = res.data as ApiResponse<Defect[]>;
            if (response.isSuccessful) {
                return [...(response.data ?? [])].sort((a, b) =>
                    (b.dateCreated ?? "").localeCompare(a.dateCreated ?? "")
                );
            }
            return [];
        } catch (error) {
            return null;
        }
    }

    async GetDefect(defectId: number): Promise<Defect | null> {
        try {
            const res = await getAxios(this.baseUrl).get(`/Stock/get/defect/by/id/${defectId}`);
            const response = res.data as ApiResponse<Defect>;
            if (response.isSuccessful) return response.data;
            return null;
        } catch (error) {
            return null;
        }
    }
}

export const DefectService = new _DefectService();
